export default "__VITE_ASSET__MYIiqowy__"